<template>
  <div class="touchpoints-snapshot-wrap">
    <v-row no-gutters>
      <v-col cols="4">
          <v-text-field
            v-if="table.totalItems > 0"
            v-model="searchString"
            label="Search touchpoint"
            outlined
            clearable
            dense
          ></v-text-field>
      </v-col>
      <v-col cols="8">
        <div class="right d-flex align-center justify-end" v-if="table.totalItems > 0">
          <div class="pre-icon cursor-pointer mr-3 pt-1" @click="displayPre()">
            <i class="las la-chevron-circle-left"></i>
          </div>
          <div>{{getPreNumber}} - {{getNextNumber}} of {{table.totalItems}}</div>
          <div class="next-icon cursor-pointer ml-3 pt-1" @click="displayNext()">
            <i class="las la-chevron-circle-right"></i>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row class="" v-show="!table.loading && table.stage.length > 0" no-gutters>
      <v-col cols="12">
        <v-simple-table class="snap-table">
          <template v-slot:default>
            <thead>
              <tr style="border-color:#f3f1f1">
                <th class="px-2 text-left sub-heading"
                  :style="`width:${header.width};max-width:${header.width}; white-space:unset;`"
                  v-for="header in table.headers"
                  v-html="header.text"
                  :key="header.text"
                >
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in table.stage" :key="index" class="card mb-0">
                <td class="px-2 snap-data" style="width:17%;max-width:17%">
                  <p class="mb-0 font-weight-bold">
                    {{item.stage_details.title}}
                  </p>
                </td>
                <td class="px-2 text-left snap-data" style="width:8%;max-width:8%">
                  <span v-if="!item.engagement_score">--</span>
                  <span v-if="item.engagement_score">
                    {{item.engagement_score}}
                  </span>
                </td>

                <td class="px-2 text-left snap-data" style="width:8%;max-width:8%">
                  <span v-if="!item.overall_mood">--</span>
                  <img
                  v-if="item.overall_mood"
                  height="30"
                  :src="getImgUrl(`${Math.round(item.overall_mood)}`)"
                  >
                </td>

                <td class="px-2 text-left snap-data" style="width:8%;max-width:8%">
                  <span v-if="!item.chat_response_stats || !item.chat_response_stats.initiated">--</span>
                  <span v-if="item.chat_response_stats && item.chat_response_stats.initiated">
                    {{item.chat_response_stats.initiated}}
                  </span>
                </td>

                <td class="px-2 text-left snap-data" style="width:8%;max-width:8%">
                  <span v-if="!item.chat_response_stats || !item.chat_response_stats.inProgress">--</span>
                  <span v-if="item.chat_response_stats && item.chat_response_stats.inProgress">
                    {{item.chat_response_stats.inProgress}}
                  </span>
                </td>

                <td class="px-2 text-left snap-data" style="width:8%;max-width:8%">
                  <span v-if="!item.chat_response_stats || !item.chat_response_stats.completed">--</span>
                  <span v-if="item.chat_response_stats && item.chat_response_stats.completed">
                    {{item.chat_response_stats.completed}}
                  </span>
                </td>

                <td class="px-2 text-left snap-data" style="width:8%;max-width:8%">
                  <span v-if="!item.chat_response_stats || !item.chat_response_stats.chat_response_rate">--</span>
                  <span v-if="item.chat_response_stats && item.chat_response_stats.chat_response_rate">
                    {{item.chat_response_stats.chat_response_rate}} %
                  </span>
                </td>

                <td class="px-2 text-center snap-data" style="font-size:13px !important; width:20%;max-width:20%;">
                  <div v-if="!item.stage_nps_breakdown" class="pl-4">
                    Not enough data to generate analysis
                  </div>
                  <!-- <div > -->
                  <div v-show="item.stage_nps_breakdown" :id="`npsBreakdown-${item.milestoneIndex}`" class="chartdiv">
                  </div>
                  <div v-if="isChartLoading(index)" :class="`isLoading${index}`" style="position: absolute;left:35%;top:40%">
                    <v-btn :loading="true" text x-large fab></v-btn>
                    <div class="pl-1">Loading...</div>
                  </div>
                  <!-- </div> -->
                </td>

                <td class="px-2 text-left" style="width:15%;max-width:15%">
                  <v-btn color="primary" outlined
                    small
                    @click.stop="viewStage(item.stage_details)">
                    <span class="btn-text">View analysis</span>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row v-if="table.totalItems === 0">
      <v-col cols="12" class="no-data box-container">
        Not enough data to generate analysis
      </v-col>
    </v-row>
    <amara-loader
      v-show="table.loading"
    ></amara-loader>
  </div>
</template>

<script>
import axios from 'axios';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

import AmaraLoader from '../../elements/amara-loader';

import TouchpointsMixin from './touchpoints-mixin';
am4core.useTheme(am4themes_animated);

export default {
  name: 'TouchpointSnapshot',

  mixins: [TouchpointsMixin],

  components: {
    AmaraLoader
  },

  data () {
    return {
      searchString: '',
      table: {
        sortBy: 'milestone_name_asc',
        descending: false,
        sortingOptions: [{
          text: 'Touchpoint (First to Last)',
          value: 'milestone_name_asc'
        }, {
          text: 'Touchpoint (Last to First)',
          value: 'milestone_name_desc'
        }, {
          text: 'Engagement Score (Low to High)',
          value: 'engagement_score_asc'
        }, {
          text: 'Engagement Score (High to Low)',
          value: 'engagement_score_desc'
        }, {
          text: 'Participation Rate (Low to High)',
          value: 'participation_rate_asc'
        }, {
          text: 'Participation Rate (High to Low)',
          value: 'participation_rate_desc'
        }],
        searchString: '',
        totalStage: 0,
        loading: true,
        stage: [],
        headers: [{
          text: 'Touchpoints',
          value: 'milestone_name',
          align: 'left',
          width: '17%',
          sortable: false
        }, {
          text: 'Engagement \n score',
          value: 'engagement_score',
          align: 'center',
          width: '8%',
          sortable: false
        }, {
          text: 'Employees\' \n vibe',
          value: 'employee_vibes',
          align: 'center',
          width: '8%',
          sortable: false
        }, {
          text: 'Chats \n not started',
          value: 'chats_initiated',
          align: 'center',
          width: '8%',
          sortable: false
        }, {
          text: 'Chats \n in progress',
          value: 'chats_initiated',
          align: 'center',
          width: '8%',
          sortable: false
        }, {
          text: 'Chats \n completed',
          value: 'chats_completed',
          align: 'center',
          width: '8%',
          sortable: false
        }, {
          text: 'Employee \n participation \n rate',
          value: 'participation_rate',
          align: 'center',
          width: '8%',
          sortable: false
        }, {
          text: '&nbsp; &nbsp; Engagement \n scale',
          value: 'nps_breakdown',
          align: 'center',
          width: '20%',
          sortable: false
        }, {
          text: 'Actions',
          value: 'actions',
          align: 'center',
          width: '17%',
          sortable: false
        // }, {
        //   text: 'Passively Engaged',
        //   align: 'center',
        //   sortable: false,
        // }, {
        //   text: 'Highly Engaged',
        //   align: 'center',
        //   sortable: false,
        }]
      },
      npsBreakdown: [],
      searchstring: '',
      page_offset: 1,
      pageLimit: 10,
      isLoading0: true,
      isLoading1: true,
      isLoading2: true,
      isLoading3: true,
      isLoading4: true,
      isLoading5: true,
      isLoading6: true,
      isLoading7: true,
      isLoading8: true,
      isLoading9: true
    };
  },

  created () {
    this.getStages();
  },

  computed: {
    getPreNumber () {
      this.resetChartLoaders();
      const num = (this.page_offset - 1) * this.pageLimit + 1;
      if (num > this.table.totalItems) {
        return this.table.totalItems;
      }
      return num;
    },
    getNextNumber () {
      this.resetChartLoaders();
      const num = (this.page_offset - 1) * this.pageLimit + this.pageLimit;
      if (num > this.table.totalItems) {
        return this.table.totalItems;
      }
      return num;
    }
  },

  beforeDestroy () {
    am4core.disposeAllCharts();
  },
  watch: {
    searchString: {
      deep: true,
      handler () {
        this.searchStage();
      }
    }
  },
  methods: {
    searchStage () {
      this.table.loading = true;
      const filters = Object.assign({}, this.updateDashboardFilters);
      if (filters && filters.filters) {
        // filters.filters have the dynamic filters value
        delete filters.filters;
      }
      const queryParams = {
        page_offset: this.page_offset,
        page_limit: this.pageLimit,
        ...filters
      };
      if (this.updateDashboardFilters && this.updateDashboardFilters.filters) {
        this.$lodash.each(this.updateDashboardFilters.filters, (v, k) => {
          if (v.length > 0) {
            queryParams[`user__profile__${k}__in`] = v.join();
          }
        });
      }
      this.npsBreakdown = [];
      axios.get(`${process.env.VUE_APP_API_URL}stage/list?fields=id,title,status,stageIndex,createdAt,engagement_score,overall_mood,chat_response_stats,stage_response_breakdown&raw_search_string=${this.searchString ? this.searchString : ''}`, {
        params: queryParams
      }).then((response) => {
        if (response && response.data) {
          const temp = response.data.data;
          this.$lodash.each(temp, (milestone, index) => {
            milestone.milestoneIndex = index;
          });
          this.table.stage = temp;
          this.table.totalItems = response.data.total_count;
          setTimeout(() => {
            this.sortStageData();
          }, 50);
          setTimeout(() => {
            this.table.loading = false;
          }, 500);
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to fetch touchpoints, Please try again later!'
          });
        }
      });
    },
    resetChartLoaders () {
      this.isLoading0 = true;
      this.isLoading1 = true;
      this.isLoading2 = true;
      this.isLoading3 = true;
      this.isLoading4 = true;
      this.isLoading5 = true;
      this.isLoading6 = true;
      this.isLoading7 = true;
      this.isLoading8 = true;
      this.isLoading9 = true;
    },
    isChartLoading (idx) {
      return this[`isLoading${idx}`];
    },
    displayPre () {
      if (this.page_offset > 1) {
        this.page_offset = this.page_offset - 1;
        this.getStages();
      }
    },
    displayNext () {
      if (this.page_offset < (this.table.totalItems / this.pageLimit)) {
        this.page_offset = this.page_offset + 1;
        this.getStages();
      }
    },
    getImgUrl (pet) {
      const images = require.context('@/assets/', false, /\.png$/);
      return images(`./${pet}.png`);
    },
    sortStageData () {
      this.$lodash.each(this.table.stage, (milestone, index) => {
        this.getNPSBreakdown(milestone.stage_nps_breakdown, index);
      });
    },
    getNPSBreakdown (data, index) {
      const temp = { ...data };
      temp.category = `nps${index}`;
      const t = [];
      t.push(temp);
      this.createBarStackChart(index, t);
    },
    createBarStackChart (index, data) {
      var chart = am4core.create(`npsBreakdown-${index}`, am4charts.XYChart);
      chart.hiddenState.properties.opacity = 1; // this creates initial fade-in
      chart.data = data;
      chart.colors.step = 2;
      var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = 'category';
      categoryAxis.renderer.grid.template.disabled = true;
      categoryAxis.renderer.labels.template.disabled = true;

      var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
      valueAxis.min = 0;
      valueAxis.max = 100;
      valueAxis.strictMinMax = true;
      valueAxis.calculateTotals = true;
      valueAxis.renderer.grid.template.disabled = true;
      valueAxis.renderer.labels.template.disabled = true;

      var series1 = chart.series.push(new am4charts.ColumnSeries());
      series1.columns.template.width = am4core.percent(80);
      series1.columns.template.tooltipText = '{name}: {valueX}';
      series1.name = 'Disengaged';
      series1.dataFields.categoryY = 'category';
      series1.dataFields.valueX = 'negative';
      series1.dataFields.valueXShow = 'totalPercent';
      series1.stacked = true;
      // series1.fill = '#f44336';
      series1.fill = '#f77b72';
      series1.fillOpacity = 1;
      // series1.fill = 'rgba(244, 67, 54, 0.2)';
      series1.stroke = 0;

      var bullet1 = series1.bullets.push(new am4charts.LabelBullet());
      bullet1.label.text = '{valueX}';
      bullet1.locationX = 0.5;
      bullet1.label.fill = am4core.color('#ffffff');

      var series2 = chart.series.push(new am4charts.ColumnSeries());
      series2.columns.template.width = am4core.percent(80);
      series2.columns.template.tooltipText = '{name}: {valueX}';
      series2.name = 'Passively Engaged';
      series2.dataFields.categoryY = 'category';
      series2.dataFields.valueX = 'neutral';
      series2.dataFields.valueXShow = 'totalPercent';
      series2.stacked = true;
      // series2.fill = '#ff9800';
      series2.fill = '#ffb64c';
      series2.stroke = 0;
      var bullet2 = series2.bullets.push(new am4charts.LabelBullet());
      bullet2.label.text = '{valueX}';
      bullet2.locationX = 0.5;
      bullet2.label.fill = am4core.color('#ffffff');

      var series3 = chart.series.push(new am4charts.ColumnSeries());
      series3.columns.template.width = am4core.percent(80);
      series3.columns.template.tooltipText = '{name}: {valueX}';
      series3.name = 'Highly Engaged';
      series3.dataFields.categoryY = 'category';
      series3.dataFields.valueX = 'positive';
      series3.dataFields.valueXShow = 'totalPercent';
      series3.dataItems.template.locations.categoryX = 0.5;
      series3.stacked = true;
      // series3.fill = '#37b99c';
      series3.fillOpacity = 1;
      series3.fill = '#92ee92';
      series3.stroke = 0;
      var bullet3 = series3.bullets.push(new am4charts.LabelBullet());
      bullet3.label.text = '{valueX}';
      bullet3.locationX = 0.5;
      bullet3.label.fill = am4core.color('#ffffff');
      chart.preloader.disabled = true;
      const that = this;
      chart.events.on('ready', function (ev) {
        const temp = `isLoading${index}`;
        that[temp] = false;
      });
    },
    viewStage (stage) {
      this.$router.push({
        path: `/lifecycle/view/${stage.id}`,
        query: { stage: stage.title }
      }).catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.touchpoints-snapshot-wrap {
  // box-shadow: 0 4px 16px 11px rgba(0, 0, 0, 0.06),0 4px 8px rgba(0, 0, 0, 0.1) !important;
  margin: 12px 10px;
  // padding-bottom: 30px;
  .no-data {
    width: 100%;
    text-align: center;
    height: 6rem;
    align-items: center;
    display: flex;
    justify-content: center;
    border: none !important;
  }
  .chartdiv {
    width: 300px;
    height: 60px;
    // top: 10px;
    // position: relative;
  }
  .sub-heading {
    font-size: var(--content-size) !important;
    color: var(--color-text) !important;
  }
  .snap-data {
    font-size: var(--content-sub-size) !important;
    color: var(--color-text) !important;
    position: relative;
  }
  .snap-table {
    box-shadow: 0 4px 16px 11px rgba(0, 0, 0, 0.06),0 4px 8px rgba(0, 0, 0, 0.1) !important;
  }
}
</style>
